import DataList from "../../../../component/DataList";
import React from "react";

export default function CompletionList() {
  return (
    <>
      <DataList
        url={`/erp/sku/workshop/getCompletionList`}
        sorter={{ field: "createTime", order: "descend" }}
        descriptions={[
          {
            fieldName: "orderNo",
            fieldShowName: "批号",
            width: 120,
          },
          {
            fieldName: "workshopId",
            fieldShowName: "车间",
            width: 100,
            inputType: 6,
            dictionary: "erp_workshop",
          },
          {
            fieldName: "procedureId",
            fieldShowName: "工序",
            width: 100,
            inputType: 6,
            dictionary: "erp_procedure",
          },
          {
            fieldName: "orderCalType",
            fieldShowName: "类型",
            width: 100,
            inputType: 6,
            dictionary: "dict_order_production_cal_type",
          },
          {
            fieldName: "joinedStaffsId",
            fieldShowName: "参与员工",
            width: 100,
            inputType: 6,
            dictionary: "base_staff",
          },
          {
            fieldName: "staffId",
            fieldShowName: "员工",
            width: 100,
            inputType: 6,
            dictionary: "base_staff",
          },
          {
            fieldName: "quantity",
            fieldShowName: "组数",
            width: 50,
            inputType: 2,
          },
          {
            fieldName: "piecesQuantity",
            fieldShowName: "柱/档数",
            width: 50,
            inputType: 2,
          },
          {
            fieldName: "type",
            fieldShowName: "方式",
            width: 100,
            inputType: 6,
            dictionary: "dict_task_completion_type",
          },
          {
            fieldName: "formulaName",
            fieldShowName: "图号",
            width: 120,
          },
          {
            fieldName: "skuName",
            fieldShowName: "产品",
            width: 120,
          },
          {
            fieldName: "length",
            fieldShowName: "长度",
            width: 120,
          },
          {
            fieldName: "creationTime",
            fieldShowName: "填报日期",
            width: 120,
          },
        ]}
      />
    </>
  );
}
